import React, { useState, useEffect } from "react";
import "./Wishlist_page.css";
import Top_Header from "./Top_Header";
import Header from "./Header";
import About_p from "./About_p";
import Footer from "./Footer";
import ImageSlider from './ImageSlider'
import StickyComponent from "./Sticky_component";

const WishlistPage = () => {
  const [wishlistItems, setWishlistItems] = useState([]);

  useEffect(() => {
    const storedWishlist = localStorage.getItem("wishlist");
    if (storedWishlist) {
      try {
        const parsedWishlist = JSON.parse(storedWishlist);
        setWishlistItems(parsedWishlist);
      } catch (error) {
        console.error("Error parsing wishlist data from localStorage:", error);
      }
    }
  }, []);

  // Function to remove an item from the wishlist
  const removeItem = (model) => {
    const updatedWishlist = wishlistItems.filter(item => item.model !== model);
    setWishlistItems(updatedWishlist);
    localStorage.setItem("wishlist", JSON.stringify(updatedWishlist));
  };

  // Function to handle adding an item to the cart
  const handleAddToCart = (item) => {
    // Add your logic here to add the item to the cart
    //console.log("Adding item to cart:", item);
  };

  function handleCartClick(product) {
    const cart = JSON.parse(localStorage.getItem('cart')) || [];
    const existingItemIndex = cart.findIndex(item => item.model === product?.Model);
    if (existingItemIndex !== -1) {
      cart[existingItemIndex].quantity += 1;
    } else {
      cart.push({
        model: product?.model,
        name: product?.name,
        price: product?.sale_price || product?.regular_price,
        url: product?.image,
        quantity: 1
      });
    }
    removeItem(product?.model);
    localStorage.setItem('cart', JSON.stringify(cart));
  }

  return (
    <>
      <Top_Header />
      <Header />
      <ImageSlider></ImageSlider>
      <div className="wishlist-page-title">
        <h1>Wishlist</h1>
      </div>
      <div className="wishlist-page-table-container">
        {wishlistItems.length > 0 ? (
          <table className="wishlist-page-table">
            <thead>
              <tr>
                <th></th>
                <th>Product</th>
                <th>Price</th>
                <th>In Stock</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {wishlistItems.map((item, index) => (
                <tr key={index}>
                  <td className="wishlist-delete-item">
                    <button
                      onClick={() => removeItem(item?.model)}
                      className="wishlist-delete-item-btn"
                      aria-label="Remove item"
                    >
                      X
                    </button>
                  </td>
                  <td>
                    <div className="wishlist-product-info">
                      <img src={item?.image} alt="Product" />
                      <span>{item?.name}</span>
                    </div>
                  </td>
                  <td>
                    ₹
                    {item?.sale_price ? (
                      <>
                        <span className="wishlist-price">{item?.sale_price}</span> <span className="wishlist-mrp">MRP:{item?.regular_price}</span>
                      </>
                    ) : (
                      <span className="wishlist-price">item?.regular_price</span>
                    )}{" "}
                    Inclusive of all taxes
                  </td>
                  <td>{item?.in_stock ? "Yes" : "No"}</td>
                  <td>
                    <button
                      onClick={() => handleCartClick(item)}
                      className="wishlist-add-to-cart-btn"
                    >
                      Add to Cart
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="empty-message">No items in your wishlist.</p>
        )}
      </div>
      <About_p />
      <Footer />

      <StickyComponent />
    </>
  );
};

export default WishlistPage;
